import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './index.css';

import { Worker } from '@react-pdf-viewer/core';
import { router } from './routes.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Worker
      workerUrl={`https://unpkg.com/pdfjs-dist@3.8.162/build/pdf.worker.min.js`}
    >
      <RouterProvider router={router} />
    </Worker>
  </React.StrictMode>
);
